import './ProjectLocation.css';

export default function ProjectLocation({ project }) {
  const { location, name } = project;
  if (!location?.display) return null;

  const { display, area, mapEmbedUrl, nearby = [] } = location;

  return (
    <section className="pd-section pd-section--alt">
      <div className="pd-section__inner pd-loc">
        <div className="pd-loc__text">
          <p className="pd-eyebrow">Location</p>
          <h2 className="pd-title">
            {area ? `Prime ${area.split(',').pop().trim()} location` : 'Location'}
          </h2>
          <p className="pd-loc__address">{display}</p>

          {nearby.length > 0 && (
            <ul className="pd-loc__nearby">
              {nearby.map((n) => (
                <li key={n.label} className="pd-loc__nearby-item">
                  <span className="pd-loc__nearby-label">{n.label}</span>
                  {n.detail && <span className="pd-loc__nearby-detail">{n.detail}</span>}
                </li>
              ))}
            </ul>
          )}
        </div>

        {mapEmbedUrl && (
          <div className="pd-loc__map">
            <iframe
              src={mapEmbedUrl}
              title={`Map showing ${name} location`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        )}
      </div>
    </section>
  );
}
